import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class UINotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showSimpleSnack(
    message: string,
    error: boolean = false,
    actionButton?: string,
    duration?: number
  ) {
    const conf = {
      panelClass: error ? 'error' : '',
      duration: duration || 6000,
    } as MatSnackBarConfig;

    return this.snackBar.open(message, actionButton, conf);
  }
}
